// Geo-based access restrictions using Shopify `/browsing_context_suggestions.json`
// - Block access to global store from specific countries
// - Special handling for Korean visitors (hide purchase actions)

(function () {
  var BLOCKED_COUNTRIES = ['AU', 'US', 'TH', 'GB', 'JP','TW'];
  var KOREA_CODE = 'KR';
  var DEBUG_GEO = true;

  function getCountryName(code) {
    try {
      if (window.Intl && typeof Intl.DisplayNames === 'function') {
        var dn = new Intl.DisplayNames(['en'], { type: 'region' });
        return dn.of(String(code).toUpperCase()) || null;
      }
    } catch (e) {}
    return null;
  }

  function debugLogCountry(code, source) {
    if (!DEBUG_GEO || !code || typeof console === 'undefined') return;
    try {
      var upper = String(code).toUpperCase();
      var name = getCountryName(upper);
      console.log('[geo] detected country:', upper + (name ? ' — ' + name : ''), source ? '(' + source + ')' : '');
    } catch (e) {}
  }

  function ensureOverlayStyles() {
    if (document.getElementById('geo-block-overlay-style')) return;

    var style = document.createElement('style');
    style.id = 'geo-block-overlay-style';
    style.textContent =
      '.geo-block-overlay{' +
      'position:fixed;z-index:99999;inset:0;background:#050505;color:#ffffff;' +
      'display:flex;align-items:center;justify-content:center;padding:24px;' +
      'font-family:system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,sans-serif;' +
      '}' +
      '.geo-block-overlay__inner{max-width:480px;text-align:center;color:#ffffff}' +
      '.geo-block-overlay__title{font-size:28px;letter-spacing:.15em;text-transform:uppercase;margin-bottom:12px;color:#ffffff}' +
      '.geo-block-overlay__subtitle{font-size:14px;opacity:.75;margin-bottom:20px;color:#ffffff}' +
      '.geo-block-overlay__text{font-size:14px;line-height:1.6;margin-bottom:8px;color:#ffffff}' +
      '.geo-block-overlay a{color:#ffffff;text-decoration:underline;color:#ffffff}' +
      '.geo-block-overlay__logo{font-size:32px;letter-spacing:.25em;text-transform:uppercase;margin-bottom:20px;color:#ffffff}' +
      'body{overflow:hidden;color:#ffffff}';

    document.head.appendChild(style);
  }

  function showBlockedOverlay(countryCode) {
    ensureOverlayStyles();

    var overlay = document.createElement('div');
    overlay.className = 'geo-block-overlay';

    overlay.innerHTML =
      '<div class="geo-block-overlay__inner">' +
      '<div class="geo-block-overlay__logo">ADRO</div>' +
      '<div class="geo-block-overlay__title">Opening soon</div>' +
      '<p class="geo-block-overlay__subtitle">ADRO Global is not yet available in your region (' +
      String(countryCode || '').toUpperCase() +
      ').</p>' +
      '<p class="geo-block-overlay__text">For customers in the United States, please visit <a href="https://adro.com/" rel="noopener">ADRO US</a>.</p>' +
      '<p class="geo-block-overlay__text">For customers in Japan, please visit <a href="https://adro-japan.myshopify.com/" rel="noopener">ADRO JP</a>.</p>' +
      '<p class="geo-block-overlay__text">Thank you for your interest in ADRO. We look forward to launching in more regions soon.</p>' +
      '</div>';

    document.body.appendChild(overlay);
  }

  function hideKoreaAtcAndCheckout(root) {
    if (!root) return;
    // Allow Document (9) and DocumentFragment (11) as well as Element (1)
    if (root.nodeType !== 1 && root.nodeType !== 9 && root.nodeType !== 11) return;
    var sel = '.product-form__submit, .quick-add__submit, .cart__checkout-button, button[name="checkout"], button[name="add"][type="submit"], a[data-checkout-inquiry-popup], #checkout, #CartDrawer-Checkout';
    try {
      root.querySelectorAll(sel).forEach(function (el) { el.style.display = 'none'; });
    } catch (e) {}
  }

  function applyKoreaRestrictions() {
    function run() {
      hideKoreaAtcAndCheckout(document);
      setTimeout(function () { hideKoreaAtcAndCheckout(document); }, 300);
      setTimeout(function () { hideKoreaAtcAndCheckout(document); }, 1000);
      if (window.MutationObserver && document.body) {
        var obs = new MutationObserver(function (mutations) {
          mutations.forEach(function (m) {
            m.addedNodes.forEach(function (node) {
              if (node && node.nodeType === 1) hideKoreaAtcAndCheckout(node);
            });
          });
        });
        obs.observe(document.body, { childList: true, subtree: true });
      }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
  }

  function handleCountry(code) {
    if (!code) return;

    // Normalize to upper case ISO code
    code = String(code).toUpperCase();
    debugLogCountry(code, 'handleCountry');

    // Special handling for Korea: site accessible, but no checkout/add-to-cart
    if (code === KOREA_CODE) {
      applyKoreaRestrictions();
      return;
    }

    // Block access for specified countries
    if (BLOCKED_COUNTRIES.indexOf(code) === -1) {
      return;
    }

    if (code === 'US') {
      window.location.href = 'https://adro.com/';
      return;
    }

    if (code === 'JP') {
      window.location.href = 'https://adro-japan.myshopify.com/';
      return;
    }

    var show = function () {
      showBlockedOverlay(code);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', show);
    } else {
      show();
    }
  }

  function init() {
    var q = typeof window !== 'undefined' && window.location && window.location.search;
    var force = q && (window.location.search.match(/[?&]geo_country=([A-Za-z]{2})/) || [])[1];
    if (force) { debugLogCountry(force, 'query'); handleCountry(force.toUpperCase()); return; }

    if (typeof window.fetch !== 'function') return;
    try {
      fetch('/browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false', { credentials: 'same-origin' })
        .then(function (response) { return response && response.ok ? response.json() : null; })
        .then(function (data) {
          var code = null;
          if (data) {
            var c = (data.detected_values && data.detected_values.country) || (data.suggestions && data.suggestions[0] && data.suggestions[0].parts && data.suggestions[0].parts.country);
            code = c && (c.handle || c.iso_code || c.code);
          }
          if (!code && window.__themeCountryCode) code = window.__themeCountryCode;
          if (code) { debugLogCountry(code, data ? 'browsing_context_suggestions' : 'theme'); handleCountry(String(code).toUpperCase()); }
        })
        .catch(function () {});
    } catch (e) {}
  }

  init();
})();

